class UnsubscribeLegaldocButtonComponent {
  constructor(Orders, toastr) {
    Object.assign(this, {
      Orders,
      toastr,
      unsubscribing: false,
      unsubscribed: false,
    });
  }

  unsubscribe() {
    this.unsubscribing = true;
    this.Orders.unsubscribeFromLegaldoc(this.dispenseOrderId, this.orderId)
      .then(({}) => {
        this.unsubscribed = true;
      })
      .catch((err) => {
        this.toastr.error(`Failed to process request: <br><br>${err.config.method} -> ${err.config.url} <br>${err.data.status}: ${err.data.message}`);
      })
      .finally(() => {
        this.unsubscribing = false;
      });
  }
}

UnsubscribeLegaldocButtonComponent.$inject = ['Orders', 'toastr'];
angular.module('pims').component('unsubscribeLegaldocButton', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/components/unsubscribe-legaldoc/unsubscribe-legaldoc-button.component.html',
  controller: UnsubscribeLegaldocButtonComponent,
  controllerAs: 'vm',
  bindings: {
    dispenseOrderId: '=',
    orderId: '=',
  }
});
